import { FC } from "react";

import { type PresentationBannerColorType } from "components/footer/PresentationBanner";
import { t } from "i18n/i18n";
import { PillButton } from "mds/components/PillButton";

export type MovePresentationButtonProps = {
  onClick: () => void;
  color: PresentationBannerColorType;
};

export const MovePresentationButton: FC<MovePresentationButtonProps> = ({ onClick, color }) => {
  return (
    <PillButton
      eventName="Presentation - Move presentation here"
      kind={`banner-${color}`}
      size="s"
      onClick={onClick}
    >
      {t("main_header.move_presentation")}
    </PillButton>
  );
};
